<template>
  <div class="bg-light p-3 border-top">
    <ColBase class="col">
      <PlaceholderWrapperBase :loading="loadingState">
        <div class="d-flex align-items-baseline">
          <h4>Total</h4>
          <span class=""> ({{ itemCount }})</span>
          <span class="ms-auto">{{ toCash(checkoutTotal) }}</span>
        </div>
        <small v-if="taxPercent !== 0">Taxes calculated at checkout.</small>
      </PlaceholderWrapperBase>
      <div class="d-flex flex-column gap-2 mt-1">
        <ButtonSubmit
          v-if="canCheckout"
          class="btn-block"
          @click="onCheckout"
        >
          Checkout
        </ButtonSubmit>
        <ButtonSubmit v-else class="btn-block disabled"
          >Checkout</ButtonSubmit
        >
        <ButtonSecondary
          class="btn-block"
          @click="onContinueShopping"
        >
          Continue Shopping
        </ButtonSecondary>
      </div>
    </ColBase>
  </div>
</template>

<script setup lang="ts">
import { PlaceholderWrapperBase } from '@/components/base';
import ColBase from '@/components/base/Grid/ColBase.vue';
import { ButtonSecondary, ButtonSubmit } from '@/components/ui';
import { useMoney } from '@/composables/useMoney';

const { toCash } = useMoney();

defineOptions({ name: 'CartSummaryFooter' });

const { canCheckout, checkoutTotal, itemCount, loadingState, taxPercent } =
  defineProps<{
    canCheckout: boolean;
    checkoutTotal: number;
    itemCount: number;
    loadingState: boolean;
    taxPercent: number;
  }>();

const emit = defineEmits<{
  (e: 'checkout'): void;
  (e: 'continueShopping'): void;
}>();

const onCheckout = () => emit('checkout');
const onContinueShopping = () => emit('continueShopping');
</script>
